import { getColorScales } from '@/components/Charts/utils/getScales';
import type { Data } from '@/types/chart';
import DataPoint from './DataPoint';

const PLACEHOLDER_POINT: Data = { value: 0, label: 'Stockholm', periodLabel: 'Vecka: 44 2026', date: '' };

const DataPointList = ({ latestDataPoints, unit }: { latestDataPoints: Data[] | null; unit?: string }) => {
  const colors = getColorScales({
    numberOfColors: latestDataPoints?.length || 1,
    numberOfComparisons: latestDataPoints?.length || 1,
  });

  if (!latestDataPoints) {
    return (
      <div className='grid'>
        <div
          aria-hidden
          className='invisible col-start-1 row-start-1'
        >
          <DataPoint
            point={PLACEHOLDER_POINT}
            unit={unit}
            color='transparent'
          />
        </div>
        <DataPoint
          point={null}
          unit={unit}
          color={String(colors[0]?.default(0))}
          className='col-start-1 row-start-1'
        />
      </div>
    );
  }

  return (
    <>
      {latestDataPoints.map((d, i) => {
        const color = String(colors[i]?.default(0));
        return (
          <DataPoint
            // biome-ignore lint/suspicious/noArrayIndexKey: latestDataPoints has no stable unique field — `id` can be undefined and `label` can duplicate (e.g. two points for the same address). This is a fixed positional display that isn't reordered, so the index is the safe key.
            key={i}
            point={d}
            unit={unit}
            color={color}
          />
        );
      })}
    </>
  );
};
export default DataPointList;
